import styled from '@emotion/styled';
import { Container } from 'components/Layout';
import { useMemo } from 'react';
import { NoReportDataMessage } from 'components/ReportsComponents/NoReportDataMessage';
import {
  columns,
  groupSummaryItems,
  SLA_PERFORMANCE_REPORT,
  SLA_PERFORMANCE_TITLE,
  summaryItems,
} from './constants';
import { GroupCellContent } from './GroupCellContent';
import { sortReportData } from './helpers/sortReportData';
import { SLAReportTableProps } from './types';
import DevExtremeReportGrid from 'components/ReportGrid_New';
import { noPDFexportFormats } from 'components/ReportGrid_New/constants';
import { cellPrepared } from './helpers/cellPrepared';
import { customizeCell } from './helpers/customizeCell';
import { calculateSelectedRow } from './helpers/calculateSelectedRow';

// TODO: sorting doesn't work
export function SLAReportTable({
  reportData,
  isReportFetching,
  reportHeaderTagLine,
}: Readonly<SLAReportTableProps>) {
  const rows = useMemo(() => sortReportData(reportData), [reportData]);

  return (
    <>
      {!isReportFetching && rows && rows?.length === 0 && (
        <NoReportDataMessage />
      )}
      <ReportGridContainer direction="column">
        <DevExtremeReportGrid
          allowSorting={false}
          calculateSelectedRow={calculateSelectedRow}
          cellPrepared={cellPrepared}
          columns={columns}
          customizeCell={customizeCell}
          exportFormats={noPDFexportFormats}
          groupCellContent={(options) => GroupCellContent(reportData, options,)}
          headerTitleForSheet={SLA_PERFORMANCE_REPORT}
          isLoading={isReportFetching}
          reportHeaderTagLine={reportHeaderTagLine}
          rows={rows}
          showFiltering={false}
          showSelection={false}
          summaryItems={summaryItems}
          groupSummaryItems={groupSummaryItems}
          title={SLA_PERFORMANCE_TITLE}
        />
      </ReportGridContainer>
    </>
  );
}

const ReportGridContainer = styled(Container)`
  padding-left: ${({ theme }) => theme.padding.xl};
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    padding: 0 20px;
  }
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
    padding: 0 15px;
  }
  .Content-columnTitle {
    strong {
      display: none !important;
    }
    white-space: pre-line;
  }
`;
